import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { company } from '~/company/Company';
import CloudflareResponseImage from '~/components/CloudflareResponsiveImage/CloudflareResponseImage';
import { defaultSrcSetParams } from '~/components/CloudflareResponsiveImage/constants';
import { formatVolume } from '~/components/ProductCard/utils';
import { Offer } from '~/stores/CategoriesStore';
import { formatPriceWithCurrency } from '~/utils/formaters';

import styles from './BundleList.module.scss';

interface BundleListProps {
  isBundle: boolean;
  offers: Offer[];
}

const BundleList = observer(({ isBundle, offers }: BundleListProps) => {
  const { t } = useTranslation();

  if (!isBundle) {
    return null;
  }

  return (
    <div className={styles.bundleList}>
      <p className={styles.bundleList_title}>{t('bundleList')}</p>
      <ul className={styles.bundleList_content}>
        {offers.map((i) => {
          const measure = formatVolume(i.properties, {
            defaultVolume: company.config.defaultVolumeDisplay,
          });
          const price = i.discountPrice
            ? i.discountPriceFormatted
            : i.priceFormatted;
          const bundleCount = i.bundleQuantity ?? 1;

          return (
            <Link data-link="bundle-item" key={i.id} to={`/p/${i.productSlug}`}>
              <li className={styles.bundleList_contentItem}>
                <CloudflareResponseImage
                  src={i.previewImageThumb || ''}
                  srcParams={{ width: 100, height: 140 }}
                  srcSetParams={defaultSrcSetParams}
                  className={styles.bundleList_contentItem_image}
                  loading="lazy"
                  alt=""
                />
                <div
                  className={
                    styles.bundleList_contentItem_contentDescriptionContainer
                  }
                >
                  <div
                    className={styles.bundleList_contentItem_contentDescription}
                  >
                    <p className={styles.name}>{i.name}</p>
                    <p className={styles.price}>
                      <span>
                        {formatPriceWithCurrency(
                          +price * (i.bundleQuantity ?? 1),
                        )}
                      </span>
                      <p className={styles.measure}>
                        {formatPriceWithCurrency(price)}
                        {' • '}
                        {measure ?? company.config.defaultVolumeDisplay}
                      </p>
                    </p>
                  </div>
                  <div className={styles.bundleList_contentItem_contentCount}>
                    <p>{bundleCount}x</p>
                  </div>
                </div>
              </li>
            </Link>
          );
        })}
      </ul>
    </div>
  );
});

export default BundleList;
